import type { NextRouter } from 'next/router';

/**
 * When the user opens sign-in from a public hotel page, the member webapp expects
 * external-login?redirect=hotel/{numericId} (path after /ile/, no leading slash).
 */
export function getHotelMemberSignInRedirectFromRouter(
  pathname: string,
  query: NextRouter['query']
): `hotel/${string}` | undefined {
  if (pathname !== '/our-hotels/[idHotel]') {
    return undefined;
  }
  const raw = query.idHotel;
  const id = Array.isArray(raw) ? raw[0] : raw;
  if (typeof id !== 'string' || !/^\d+$/.test(id)) {
    return undefined;
  }
  return `hotel/${id}`;
}
